import type { TransactionReceipt } from '@ethersproject/providers'
import type { BigNumber } from '@ethersproject/bignumber'
import type { ContractTransaction } from '@ethersproject/contracts'
import { WalletModalErrorCodes, ERC20Names, SupportedNetworkIDs } from '../../../types'

export enum TransactionStatus {
  FAILED,
  NOT_SUBMITTED,
  SUBMITTED,
  COMPLETE,
  NOT_STARTED,
}

export interface TransactionData {
  receipt?: TransactionReceipt
  submittedTx?: ContractTransaction
  chainId?: SupportedNetworkIDs
  message: string
}

export interface TransactionState {
  loading: boolean
  txStatus: TransactionStatus
  data: TransactionData
  error?: WalletModalError
  submitCount: number
}

export interface ERC20BalanceResultAmount {
  wei: { [k in ERC20Names]?: BigNumber }
  human: { [k in ERC20Names]?: string }
}

export interface ERC20BalanceResult {
  total: ERC20BalanceResultAmount
  locked?: ERC20BalanceResultAmount
}
export interface ERC20BalanceState {
  loading: boolean
  balances?: ERC20BalanceResult
  error?: WalletModalError
}

export interface SwitchChainState {
  loading: boolean
  resetCount: number
  error?: WalletModalError
}

export interface WalletModalError {
  detail: Error
  code: WalletModalErrorCodes
}

export type TransactionActionTypes = 'submit' | 'complete' | 'loading' | 'failure' | 'reset'

export type TransactionAction =
  | { type: 'submit'; transaction: ContractTransaction; message: string; chainId: number }
  | { type: 'complete'; receipt: TransactionReceipt; message: string }
  | { type: 'loading' }
  | {
      type: 'failure'
      error: string | Error
      code: WalletModalErrorCodes
      transactionStatus: TransactionStatus
    }
  | { type: 'reset' }

export type ERC20BalanceAction =
  | { type: 'loading' }
  | { type: 'success'; balances: ERC20BalanceResult }
  | { type: 'failure'; error: string | Error; code: WalletModalErrorCodes }
  | { type: 'reset' }

export type SwitchChainAction =
  | { type: 'loading' }
  | { type: 'success' }
  | { type: 'reset' }
  | { type: 'failure'; error: string | Error; code: WalletModalErrorCodes }
